import { createSelector } from '@reduxjs/toolkit';
import { isSuburban } from '../../../packages/JsonQuery';
import { selectOfferType } from './selectOfferType';

export const selectIsSuburbanListing = createSelector(selectOfferType, isSuburban);
